
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-unlock" })
export default class IconUnlock extends Vue {
  sData: string = require("@icon/feather/unlock.svg");
}
